$(document).on("turbo:load", () => {
  $('[data-toggle="tooltip"]').tooltip()

  // Need this for Turbo, for if user was on a different page before text/plain items were added to the body
  if(_iub.cs && _iub.cs.api.isConsentGiven()) {
    _iub.cs.api.activateSnippets()
  }
})

$(document).on("turbo:before-cache", () => {
  // Manually tear down bootstrap modals before caching. If turbo
  // caches the modal then tries to restore it, it breaks bootstrap's JS.
  // We can't just use bootstrap's `modal('close')` method because it is async.
  // Turbo will cache the page before it finishes running.
  if ($("body").hasClass("modal-open")) {
    $(".modal").hide().removeAttr("aria-modal").attr("aria-hidden", "true")
    $(".modal-backdrop").remove()
    $("body").removeClass("modal-open")
  }
})